import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import ChatWidget from "@/components/ChatWidget";
import ThemeInjector from "@/components/ThemeInjector";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Catalog from "@/pages/Catalog";
import Customizer from "@/pages/Customizer";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Payment from "@/pages/Payment";
import Orders from "@/pages/Orders";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminReport from "@/pages/AdminReport";
import InvoiceManager from "@/pages/InvoiceManager";
import AdminChatPage from "@/pages/AdminChatPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import About from "@/pages/About";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/produk" element={<Catalog />} />
      <Route path="/kustom/:productId" element={<Customizer />} />
      <Route path="/keranjang" element={<Cart />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/tentang" element={<About />} />
      <Route path="/hubungi" element={<Contact />} />
      <Route path="/syarat" element={<Terms />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
      <Route path="/pembayaran/:orderId" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
      <Route path="/pesanan" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/laporan" element={<ProtectedRoute adminOnly><AdminReport /></ProtectedRoute>} />
      <Route path="/admin/invoice" element={<ProtectedRoute adminOnly><InvoiceManager /></ProtectedRoute>} />
      <Route path="/admin/chat" element={<ProtectedRoute adminOnly><AdminChatPage /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ThemeInjector />
          <AppRouter />
          <ChatWidget />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
